import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4>Choice Network MCN</h4>
          <p>Empowering creators worldwide through investment and monetization</p>
        </div>
        
        <div className="footer-section">
          <h5>Platform</h5>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/creators">For Creators</a></li>
            <li><a href="/investors">For Investors</a></li>
            <li><a href="/channels">Our Channels</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h5>Support</h5>
          <ul>
            <li><a href="/help">Help Center</a></li>
            <li><a href="/guidelines">Community Guidelines</a></li>
            <li><a href="/contact">Contact Us</a></li>
            <li><a href="/faq">FAQ</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h5>Legal</h5>
          <ul>
            <li><a href="/terms">Terms of Service</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/investment-terms">Investment Terms</a></li>
            <li><a href="/copyright">Copyright Policy</a></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 Choice Network. All rights reserved.</p>
        <div className="footer-stats">
          <span>10 Channels</span>
          <span>•</span>
          <span>156 Creators</span>
          <span>•</span>
          <span>50M+ Views</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
